// Imports
import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import pincode from '../modules/pincode/api/state'
import banner from '../modules/banner/api/state'
import category from '../modules/category/api/state'
// App Imports
import common from '../modules/common/api/state'
import delivery from '../modules/delivery/api/state'
import user from '../modules/user/api/state'
import bookingsReducer from "../modules/tableReservation/store/bookingSlice";
import mediaGallery from '../modules/mediaGallery/api/state'
import settingsReducer from "../modules/setting/api/state/reducers/settings";
import documentsReducer from '../modules/documentManager/api/state/reducers/documents'

// Root Reducer
const rootReducer = combineReducers({
  common,
  ...user,
  ...category,
  ...pincode,
  ...banner,
  ...delivery,
  ...mediaGallery,
  bookings: bookingsReducer,
  settings: settingsReducer,
  documents: documentsReducer
})

// Store
export const store = createStore(rootReducer, applyMiddleware(thunk))
